<template>
  <reference-layout>
    <violation-type-create-modal ref="typeModal" @submitted="listGroupModalIsSubmitted" />
    <create-modal ref="groupModal" @submitted="groupModalIsSubmitted" />

    <template #header>
      <reference-header header-title="Типы нагрузок">
        <template #header-actions>
          <div class="layout-header-action">
            <c-button
              size="small"
              class="new-violation"
              label="Новый тип нагрузки"
              :icon="{
                icon: 'plus',
                color: 'primary',
              }"
              @click="createNewViolation"
            />
          </div>
        </template>
      </reference-header>
    </template>

    <template v-if="itemsOrGroupsAreAvailable" #subheader>
      <div class="subheader__wrapper">
        <form class="subheader__form" @submit.prevent="applyFilters">
          <c-input
            v-model="filters.name"
            class="reference-reasons-for-reject-candidate__subheader__search"
            placeholder="Поиск по наименованию"
            type="text"
            :clearable="true"
            icon="search"
            @clearInput="resetFilters"
          />
        </form>
      </div>
    </template>

    <template #list>
      <violation-types-group-list
        v-if="!isLoading && isAnyItemExists"
        :selected-list-group-items-status="selectedListGroupItemsStatus"
        :filters="filters"
        @on-delete-list-group-item="onDeleteListGroupItem"
        @on-delete-list-group="onDeleteListGroup"
        @edit-list-group-item="onEditListGroupItem"
        @edit-group="onGroupEdit"
      />
      <div v-if="!itemsOrGroupsAreAvailable && !isLoading" class="no-items">Типов нагрузок пока не добавлено</div>
      <!-- <div v-if="noArchivedItems && !isLoading" class="no-items">Типов нагрузок средств в архиве пока нет</div>
      <div v-if="noActiveItems && !isLoading" class="no-items">Активных источников денежных средств пока нет</div> -->
      <div v-if="!isAnyItemExists && areFiltersApplied && !isLoading" class="no-items">
        Ничего не найдено. Попробуйте изменить параметры поиска.
      </div>
      <c-loader v-if="isLoading || isLoadingMoreData" :active="isLoading || isLoadingMoreData" :height="500" label="Загрузка типов нагрузок" />
    </template>

    <transition name="fade">
      <display-shown-items-count
        v-if="!isLoading"
        :total-items-count="totalItemsCount"
        :shown-items-count="violationsWithoutGroup.length"
      />
    </transition>
  </reference-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ReferenceLayout from "@/layouts/reference-layout";
import ReferenceHeader from "@/components/reference-components/reference-header";
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls2/Switcher";
import Loader from "@/components/loader";
import DisplayShownItemsCount from "@/components/display-shown-items-count";
import { onScrollEnd } from "@/helpers/events";

import ViolationTypesGroupList from "./list";
import ViolationTypeCreateModal from "./type-modal";
import createModal from "./group-modal";

import { param } from "@/utils/url/param";

const violationStatuses = [
  {
    label: "Все",
    value: "all",
  },
  {
    label: "Активные",
    value: "active",
  },
  {
    label: "В архиве",
    value: "archived",
  },
];

const defaultFiltersForm = {
  positions: [],
  positionsExcept: false,
  name: "",
  page: 1,
};

export default {
  name: "violation-types",
  components: {
    ReferenceLayout,
    ReferenceHeader,
    ViolationTypesGroupList,
    ViolationTypeCreateModal,
    createModal,
    DisplayShownItemsCount,
    "c-button": Button,
    "c-input": Input,
    "c-switcher": Switcher,
    "c-loader": Loader,
  },
  data() {
    return {
      bookmark: false,
      isLoading: false,
      isLoadingMoreData: false,
      areFiltersApplied: false,
      query: "",
      selectedListGroupItemsStatus: "all",
      filters: { ...defaultFiltersForm },
      violationStatuses,
      page: 1,
    };
  },
  mounted() {
    const layout = document.querySelector(".layout");
    layout.addEventListener("scroll", this.handleLayoutScroll);
  },

  beforeDestroy() {
    const layout = document.querySelector(".layout");
    layout.removeEventListener("scroll", this.handleLayoutScroll);
  },
  computed: {
    ...mapState({
      violationGroupsList: (state) => state.referenceLoadTypes.violationGroups,
      violationsWithoutGroup: (state) => state.referenceLoadTypes.violations,
      positions: (state) => state.referenceLoadTypes.positions,
      itemsAreAvailable: (state) => state.referenceLoadTypes.itemsAreAvailable,
      groupsAreAvailable: (state) => state.referenceLoadTypes.groupsAreAvailable,
      totalItemsCount: (state) => state.referenceLoadTypes.totalItemsCount,
      totalPages: (state) => state.referenceLoadTypes.totalPages,
      isMoreDataAvailable: (state) => state.referenceLoadTypes.isMoreDataAvailable,
    }),
    ...mapGetters({
      getViolation: "referenceLoadTypes/getViolation",
      isAnyArchivedItem: "referenceLoadTypes/isAnyArchivedItem",
      isAnyItemExists: "referenceLoadTypes/isAnyItemExists",
    }),
    itemsOrGroupsAreAvailable() {
      return this.itemsAreAvailable || this.groupsAreAvailable;
    },
    noArchivedItems() {
      if (this.selectedListGroupItemsStatus !== "archived" || this.areFiltersApplied) {
        return false;
      }
      if (!this.violationGroupsList.length && !this.violationsWithoutGroup.length) {
        return true;
      }
      if (!this.isAnyArchivedItem) {
        // const groupContainsItems = this.violationGroupsList.some((g) => g.hasFouls.toString() === "1");

        // if (!groupContainsItems) {
        //   return true;
        // }
      }
      return !this.isAnyArchivedItem && !this.violationGroupsList.length && !this.isLoading;
    },
    noActiveItems() {
      return (
        this.selectedListGroupItemsStatus === "active" &&
        !this.areFiltersApplied &&
        !this.isLoading &&
        !this.isAnyItemExists
      );
    },
  },
  watch: {
    selectedListGroupItemsStatus() {
      this.fetchViolationAndPositions();
      this.setFiltersToUrl();
    },
  },
  async created() {
    this.isLoading = true;
    this.getFiltersFromUrl();
    await Promise.all([
      this.fetchViolationAndPositions(),
    ]);
    this.isLoading = false;
  },
  methods: {
    handleLayoutScroll() {
      onScrollEnd(async () => {
        if (!this.isMoreDataAvailable || this.isLoading) {
          return;
        }

        if (this.filters.page < this.totalPages) {
          this.filters.page += 1;
          this.isLoadingMoreData = true;
          await this.fetchViolationAndPositions();
          setTimeout(() => {
            this.isLoadingMoreData = false;
          }, 500);
        }
      });
    },
    groupModalIsSubmitted() {
      this.fetchViolationAndPositions();
    },
    onDeleteListGroup() {
      this.fetchViolationAndPositions();
    },
    listGroupModalIsSubmitted() {
      this.filters.page = 1;
      this.fetchViolationAndPositions();
    },
    onDeleteListGroupItem() {
      this.fetchViolationAndPositions();
    },
    getFiltersFromUrl() {
      const { query } = this.$route;

      if (query.positions) {
        this.filters.positions = query.positions.split(",").map((id) => ({ value: id }));
      }

      if (query.positionsExcept) {
        this.filters.positionsExcept = query.positionsExcept === "1";
      }

      if (query.status) {
        this.selectedListGroupItemsStatus = query.status.trim();
      }
        
      if (query.name) {
        this.filters.name = query.name
      }
    },
    setFiltersToUrl() {
      const { name } = this.filters;
      const { query } = this.$route;

      let newQuery = {
          ...query,
          name:   name || "",
          status: this.selectedListGroupItemsStatus,
      };

      if (!name) {
          delete newQuery.name;
      }
      if (!this.selectedListGroupItemsStatus) {
          delete newQuery.status;
      }

      if (param(query) === param(newQuery)) return;
      this.$router.push({ query: newQuery });
    },
    async fetchViolationAndPositions() {
      if (!this.isLoadingMoreData) this.isLoading = true;
      await Promise.all([
        // await this.$store.dispatch("referenceLoadTypes/fetchViolationGroups", {
        //   ...this.filters,
        //   status: this.selectedListGroupItemsStatus,
        // }),
        await this.$store.dispatch("referenceLoadTypes/fetchListGroupItems", {
          ...this.filters,
          status: this.selectedListGroupItemsStatus,
          categories: [],
        }),
      ]);
      this.isLoading = false;
    },
    createNewViolation() {
      this.$refs.typeModal.open();
    },
    createNewViolationGroup() {
      this.$refs.groupModal.open();
    },
    onEditListGroupItem(params) {
      console.log('params', params)
      const { code, ...settings } = params;
      const violation = this.getViolation(code);
      this.$refs.typeModal.open({ ...violation }, settings);
    },
    onGroupEdit(groupId) {
      const group = this.violationGroupsList.find((g) => g.id.toString() === groupId.toString());
      this.$refs.groupModal.open({ ...group });
    },
    resetFilters() {
      this.filters = { ...defaultFiltersForm };
      this.areFiltersApplied = false;
      this.setFiltersToUrl();
      this.fetchViolationAndPositions();
    },
    async applyFilters() {
      this.isLoading = true;
      this.filters.page = 1;
      this.areFiltersApplied = true;
      this.setFiltersToUrl();
      await this.fetchViolationAndPositions();
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

// .reference-violation-types {
//   &__subheader {
//     display: flex;
//     justify-content: space-between;
//     flex-grow: 1;
//     margin-bottom: 20px;
//     max-width: 1190px;

//     &__filters {
//       display: flex;
//       margin-bottom: 41px;
//       align-items: flex-end;

//       @include mobileAndTablet {
//         flex-wrap: wrap;
//       }

//       @include onlyExtraSmall {
//         margin-bottom: 30px;
//       }

//       &__actions {
//         display: flex;
//         & > button:first-child {
//           margin-right: 10px;
//         }

//         &__reset {
//           width: 120px;
//         }
//         &__apply {
//           width: 130px;
//         }

//         @include onlyExtraSmall {
//           margin-top: 25px;
//           & > button {
//             width: 132px;
//           }

//           &__reset {
//             order: 2;
//           }
//           &__apply {
//             order: 1;
//             margin-right: 15px;
//           }
//         }
//       }
//     }

//     &__filters-item {
//       max-width: 580px;
//       margin-right: 30px;

//       &.positions {
//         width: 100%;
//         @include mobileAndTablet {
//           max-width: 100%;
//           margin-right: 0;
//         }
//       }
//       &.name {
//         width: 275px;
//         @include mobileAndTablet {
//           width: 401px;
//           margin-top: 25px;
//           margin-right: auto;
//         }
//         @include onlyExtraSmall {
//           width: 100%;
//           max-width: 100%;
//         }
//       }
//     }

//     &__actions {
//       display: flex;

//       & .new-violation {
//         margin-left: 10px;
//       }

//       @include onlyExtraSmall {
//         margin-top: 22px;

//         & .new-category {
//           width: 150px;
//           margin-left: 0;
//         }
//         & .new-violation {
//           width: 115px;
//         }
//       }
//     }

//     @include onlyExtraSmall {
//       flex-direction: column;
//     }

//     &__search {
//       flex-grow: 1;
//       max-width: 564px;

//       & /deep/ .c-input-input::placeholder {
//         font-style: italic;
//       }

//       @include onlyExtraSmall {
//         margin-top: 25px;
//       }
//     }
//   }
// }

::v-deep {

  #description-view-modal {
    display: none!important;;
  }
  .list {
    max-width: 1190px;
  }

  .list-group-item {
    max-width: 100%;
  }
  .layout-header {
    @include vp-767 {
      flex-direction: column;
    }
  }

  .h-switcher {
    margin-right: 30px;

    @include vp-767 {
      margin: 24px 0 0;
      padding: 0;
    }
  }

  .c-switcher-group {
    display: flex;
  }

  .layout-header-actions {
    @include vp-767 {
      flex-direction: column;
    }
  }

  .layout-header-action {
    @include vp-767 {
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }

  .no-items {
    color: $color-label;
    font-size: 15px;
    margin-top: 9px;

    @include onlyExtraSmall {
      padding: 0 20px;
    }
  }

  .loader {
    max-width: 1190px;
  }

  .subheader {
    flex-direction: column;
  }

  .subheader__wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    @include vp-767 {
      flex-direction: column;
    }
  }

  .subheader__form {
    width: 465px;
    max-width: 100%;

    @include vp-767 {
      margin-top: 24px;
    }
  }
}

.reference-reasons-for-reject-candidate__subheader__search {
  &::v-deep {
    input {
      &::placeholder {
        font-style: italic;
      }
    }
  }
}

::v-deep .sortable-drag .c-button_icon_arrows-constructor .c-button-icon svg path {
  fill: #0066ff !important;
}

::v-deep {
  .violation-type__remove {
    .c-button-icon {
      width: 11px;
      height: 13px;
    }
  }
}

/deep/ {
  .layout-header {
    @include vp-767 {
      margin-bottom: 3rem;
    }
  }
}
</style>
